import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import InfoIcon from '@mulesoft/anypoint-icons/lib/svg/info.svg';
import { getPath } from '~/utils/routes';
import styles from './TabPanelReview.css';

const DEFAULT_ERROR_MESSAGE =
  'Something went wrong in the scan run. Will retry in next scan.';

const getCard = (item) => item.agentCard?.card || item.agentCard || {};

const TabPanelReview = ({
  title,
  subtitle,
  typeStyle,
  agents,
  region,
  typeMsg,
  typeMsgStyle,
  displayWarning = false
}) => {
  return (
    <div data-test-id="scan-tab-panel-section">
      <div className={styles.reviewSectionTitle}>
        <p className={styles.reviewInfoLabel}>{title}</p>
        <p>{subtitle}</p>
      </div>
      <div display-if={agents.length > 0}>
        {agents.map((item) => {
          const path = getPath('assetHome', {
            groupId: item.organizationId,
            assetId: item.assetId
          });

          return (
            <div
              key={item.name}
              className={`${styles.reviewSectionContent} ${typeStyle}`}
            >
              <div className={styles.reviewInfoGrid}>
                <div className={styles.reviewInfoItem}>
                  <span>
                    <span className={styles.reviewInfoLabel}>
                      <Link data-test-id="go-to-asset" to={path}>
                        {item.name}
                      </Link>
                    </span>
                    <span className={styles.reviewInfoItemSkill}>
                      {item.version}
                    </span>
                    <span className={`${typeMsgStyle}`}>{typeMsg}</span>
                    <span className={styles.reviewInfoType}>
                      {getCard(item).provider?.organization || ''}
                    </span>
                  </span>
                  <span className={styles.reviewInfoTarget}>
                    {item.description}
                  </span>
                  <span
                    className={styles.reviewInfoWarningError}
                    display-if={displayWarning}
                  >
                    <InfoIcon />
                    <strong>Impact Analysis:</strong>{' '}
                    {item.summary?.summary || DEFAULT_ERROR_MESSAGE}
                  </span>
                </div>
                <div className={styles.reviewInfoItem}>
                  <div className={styles.reviewInfoItemDetails}>
                    <div className={styles.reviewInfoGrid}>
                      <div className={styles.reviewInfoItem}>Platform</div>
                      <div className={styles.reviewInfoItem}>
                        {getCard(item).provider?.organization || ''}
                      </div>
                    </div>
                    <div className={styles.reviewInfoGrid}>
                      <div className={styles.reviewInfoItem}>
                        Foundation model
                      </div>
                      <div className={styles.reviewInfoItem}>{}</div>
                    </div>
                    <div className={styles.reviewInfoGrid}>
                      <div className={styles.reviewInfoItem}>Agent ID</div>
                      <div className={styles.reviewInfoItem}>
                        {item.assetId}
                      </div>
                    </div>
                    <div className={styles.reviewInfoGrid}>
                      <div className={styles.reviewInfoItem}>Region</div>
                      <div className={styles.reviewInfoItem}>{region}</div>
                    </div>
                    <div className={styles.reviewInfoGrid}>
                      <div className={styles.reviewInfoItem}>Skills</div>
                      <div display-if={getCard(item).skills?.length > 0}>
                        {(getCard(item).skills || []).map((skillItem) => (
                          <span
                            key={skillItem.name}
                            className={styles.reviewInfoItemSkill}
                          >
                            {skillItem.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

TabPanelReview.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  typeStyle: PropTypes.string,
  agents: PropTypes.array,
  region: PropTypes.string,
  typeMsg: PropTypes.string,
  typeMsgStyle: PropTypes.string,
  displayWarning: PropTypes.bool
};

export default TabPanelReview;
